module.exports = __webpack_public_path__ + "img/3.afcc3ac4.png";